export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_07_XESeries.dcb6a407.mp4";